















import {formatDate, getDay} from '@/shared/filters/dates'
import {computed, defineComponent} from '@vue/composition-api'

export default defineComponent({
    name: "DateAtom",
    props: {
        eventStartDate: {
            type: String,
            required: false,
            default: ""
        },
        eventEndDate: {
            type: String,
            required: false,
            default: ""
        },
        eventDateDescription: {
            type: String,
            required: false,
            default: ""
        }
    },
    setup: (props) => {
        const formattedStartDate = computed(() => {
            return {
                date: formatDate(props.eventStartDate, 'dddd D MMMM YYYY'),
                time: formatDate(props.eventStartDate, 'HH:mm')
            }
        })
        const formattedEndDate = computed(() => {
            return {
                date: formatDate(props.eventEndDate, 'dddd D MMMM YYYY'),
                time: formatDate(props.eventEndDate, 'HH:mm')
            }
        })
        const isSameDay = computed(() => {
            return getDay(props.eventStartDate) === getDay(props.eventEndDate)
        })
        return {
            isSameDay,
            formattedEndDate,
            formattedStartDate,
        }
    }
})
